import addPastSearch from './addPastSearch'
import changeAuction from './changeAuction'
import doCompleteNewPassword from './doCompleteNewPassword'
import doResetPasswordByEmail from './doResetPasswordByEmail'
import doLogin from './doLogin'
import doLogout from './doLogout'
import AllMutations from './Mutation'
import AllQueries from './Query'
import { dashboardResolvers } from '@edge/spark/io-dashboards'
import { contactResolvers } from '../../../spark_libs_deprecated/feature-contact-modal'
import { MutationResolvers, Resolvers, QueryResolvers } from '../../../generated/graphql'

const Mutation: MutationResolvers = {
    ...AllMutations,
    addPastSearch,
    changeAuction,
    doResetPasswordByEmail,
    doCompleteNewPassword,
    doLogin,
    doLogout,
    ...dashboardResolvers.Mutation,
    ...contactResolvers.Mutation,
}

const Query: QueryResolvers = {
    ...AllQueries,
    ...dashboardResolvers.Query,
}

const resolvers: Resolvers = {
    Mutation,
    Query,
}

export default resolvers
